const data = {
	// url: "http://127.0.0.1:8080/api/"
	url: "/api/",
	protocol:"https://"
}

export default data;